// extracted by mini-css-extract-plugin
export var problemBox = "box-module--problemBox--f90fe";
export var text = "box-module--text--b6ba1";
export var x = "box-module--x--7ae37";